// Company-structure presentation config. The tree data now comes from the API
// (GET /company-structure → api/endpoints/structureApi.ts); this file only maps
// a node's numeric level → tile icon / tone / label.

export type LevelTone = 'brand' | 'amber' | 'blue' | 'violet';

export interface OrgLevel {
  level: number;
  label: string;
  icon: string; // kebab-case lucide name
  tone: LevelTone;
}

export interface OrgUnit {
  id: string;
  name: string;
  level: number;
  location: string;
  referenceNumber: number | string; // sequential node reference (ND-42)
  memberCount: number;
  /** First tag's title — kept for the single-chip display on rows/cards. */
  tag?: string;
  /** All tags on the unit (drives the tag filter). */
  tags?: { id: string; title: string }[];
  status?: 'active' | 'inactive';
  children?: OrgUnit[];
}

// Level 0 is the company root; deeper levels carry the "Level N" badge.
export const ORG_LEVELS: OrgLevel[] = [
  { level: 0, label: 'Company', icon: 'building-2', tone: 'brand' },
  { level: 1, label: 'Branch', icon: 'git-branch', tone: 'amber' },
  { level: 2, label: 'Department', icon: 'briefcase', tone: 'blue' },
  { level: 3, label: 'Sub department', icon: 'layers', tone: 'violet' },
  { level: 4, label: 'Team', icon: 'users-round', tone: 'brand' },
];

export const getLevel = (level: number): OrgLevel =>
  ORG_LEVELS.find((l) => l.level === level) ?? ORG_LEVELS[ORG_LEVELS.length - 1];
